import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { getFullAPIFileURL } from '../../../../../common/getFullAPIFileURL';
import { coverRedoMessages as messages } from './coverRedoMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover redo; each part uses its own slice of it */
import styles from './CoverRedo.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CoverRedoPairProps {
  previousUrl: string | null;
  currentUrl: string | null;
  small?: boolean;
}

/** One cover of the pair, with its tag. */
const Cover: React.FC<{ url: string; tag: string; isOld: boolean; small: boolean }> = ({ url, tag, isOld, small }) => (
  <span className={clsx(styles.cover, small && styles.coverSmall, isOld ? styles.coverOld : styles.coverNew)}>
    <img className={styles.coverImage} src={getFullAPIFileURL(url)} alt="" />
    <span className={styles.coverTag}>{tag}</span>
  </span>
);

/**
 * The old → new cover pair of the banner and the dialog head (design kit-redo-cover a1, b1). With
 * no old picture the pair shows the new cover alone; with no cover at all it shows nothing.
 */
const CoverRedoPairComponent: React.FC<CoverRedoPairProps> = ({ previousUrl, currentUrl, small = false }) => {
  const intl = useIntl();
  if (currentUrl === null && previousUrl === null) {
    return null;
  }
  return (
    <span className={styles.pair} aria-hidden="true">
      {previousUrl !== null && (
        <>
          <Cover url={previousUrl} tag={intl.formatMessage(messages.oldTag)} isOld small={small} />
          <span className={styles.arrow}>→</span>
        </>
      )}
      {currentUrl !== null && (
        <Cover url={currentUrl} tag={intl.formatMessage(messages.newTag)} isOld={false} small={small} />
      )}
    </span>
  );
};

export const CoverRedoPair = TypedMemo(CoverRedoPairComponent);
